import { ButtonComponent } from "./controls/button/button.component";
import { NgModule } from "@angular/core";
import { TextInputComponent } from "./inputs/text-input/text-input.component";
import { SwitchComponent } from "./controls/switch/switch.component";
import { ToastComponent } from "./components/toast/toast.component";
import { CheckboxComponent } from "./controls/checkbox/checkbox.component";
import { InfoCardComponent } from "./components/info-card/info-card.component";
import { SectionTitleComponent } from "./components/section-title/section-title.component";
import { LineComponent } from "./components/line/line.component";
import { LoaderComponent } from "./components/loader/loader.component";
import { HeaderComponent } from "./components/header/header.component";
import { FooterComponent } from "./components/footer/footer.component";
import { DropdownComponent } from "./controls/dropdown/dropdown.component";
import { SelectComponent } from "./inputs/select/select.component";
import { RangeComponent } from "./inputs/range/range.component";
import { InputErrorComponent } from "./inputs/input-error/input-error.component";
import { TabsComponent } from "./controls/tabs/tabs.component";
import { TabComponent } from "./controls/tabs/tab/tab.component";
import { CommonModule, NgOptimizedImage } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { TranslocoModule } from "@ngneat/transloco";
import { RouterLink } from "@angular/router";
import { NgChartsModule } from "ng2-charts";
import { GoogleMapsModule } from "@angular/google-maps";
import { DialogComponent } from './components/dialog/dialog.component';
import { FileInputComponent } from './inputs/file-input/file-input.component';
import { RoleAccessDirective } from './directives/role-access.directive';
import { HideIfLoggedInDirective } from './directives/hide-if-logged-in.directive';
import { ValueTextComponent } from './components/value-text/value-text.component';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TextareaComponent } from './inputs/textarea/textarea.component';
import { InfoDialogComponent } from './components/common-dialogs/info-dialog/info-dialog.component';
import { ConfirmDialogComponent } from './components/common-dialogs/confirm-dialog/confirm-dialog.component';
import { InfoIconComponent } from './components/info-icon/info-icon.component';
import { DateInputComponent } from './inputs/date-input/date-input.component';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MAT_DATE_LOCALE, MatNativeDateModule } from '@angular/material/core';
import { MatInputModule } from '@angular/material/input';
import { ReadonlyValueComponent } from './inputs/readonly-value/readonly-value.component';
import { FillIfEmptyValuePipe } from './pipes/fill-if-empty-value.pipe';
import { TranslateLabelsPipe } from './pipes/translate-labels.pipe';
import { TranslateStringArrayPipe } from './pipes/translate-string-array.pipe';
import { ClickOutsideDirective } from './directives/click-outside.directive';
import { MostFrequentQuestionsComponent } from './components/most-frequent-questions/most-frequent-questions.component';
import { GoogleAutocompleteComponent } from './inputs/google-autocomplete/google-autocomplete.component';


@NgModule({
  declarations: [
    ButtonComponent,
    TextInputComponent,
    SwitchComponent,
    ToastComponent,
    CheckboxComponent,
    InfoCardComponent,
    SectionTitleComponent,
    LineComponent,
    LoaderComponent,
    HeaderComponent,
    FooterComponent,
    DropdownComponent,
    SelectComponent,
    RangeComponent,
    InputErrorComponent,
    TabsComponent,
    TabComponent,
    DialogComponent,
    FileInputComponent,
    RoleAccessDirective,
    HideIfLoggedInDirective,
    ValueTextComponent,
    TextareaComponent,
    InfoDialogComponent,
    ConfirmDialogComponent,
    DateInputComponent,
    FillIfEmptyValuePipe,
    TranslateLabelsPipe,
    MostFrequentQuestionsComponent,
    GoogleAutocompleteComponent,
  ],
  exports: [
    ButtonComponent,
    TextInputComponent,
    SwitchComponent,
    ToastComponent,
    CheckboxComponent,
    InfoCardComponent,
    SectionTitleComponent,
    LineComponent,
    LoaderComponent,
    HeaderComponent,
    FooterComponent,
    SelectComponent,
    RangeComponent,
    TabsComponent,
    TabComponent,
    RoleAccessDirective,
    HideIfLoggedInDirective,
    DialogComponent,
    MatIconModule,
    MatTooltipModule,
    ValueTextComponent,
    TextareaComponent,
    FileInputComponent,
    ConfirmDialogComponent,
    InfoDialogComponent,
    DateInputComponent,
    FillIfEmptyValuePipe,
    TranslateLabelsPipe,
    MostFrequentQuestionsComponent,
    GoogleAutocompleteComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    TranslocoModule,
    RouterLink,
    ReactiveFormsModule,
    NgChartsModule,
    GoogleMapsModule,
    MatIconModule,
    MatTooltipModule,
    InfoIconComponent,
    MatDatepickerModule,
    MatNativeDateModule,
    MatInputModule,
    NgOptimizedImage,
    ReadonlyValueComponent,
    TranslateStringArrayPipe,
    ClickOutsideDirective,
  ],
  providers: [
    FillIfEmptyValuePipe,
    { provide: MAT_DATE_LOCALE, useValue: 'en-GB' },
  ],
})
export class SharedModule {
}
